<template>
	<div id="app">
		<calendar />
	</div>
</template>

<script>
import Calendar from '@/components/Calendar.vue';

export default {
	name: 'app',
	components: {
		Calendar
	}
};
</script>

<style lang="scss">
#app,
#app * {
	box-sizing: border-box;
}

#app {
	font-family: 'montserrat', sans-serif;
	max-width: 760px;
	margin: 0 auto;
	color: $teal;
	font-size: 18px;
	line-height: 1.4;
}
</style>
